import React from 'react';

export interface ArrowRightProps {
  className?: string;
}

const ArrowRight: React.FC<ArrowRightProps> = ({ className }) => {
  return (
    <svg viewBox="0 0 26 10" fill="none" className={className}>
      <path
        d="M1 5H25M25 5L21 1M25 5L21 9"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowRight;
